var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconStellerCommunication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#4E88BF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M296.9 2169h-23.8c-2.817 0-5.1 2.265-5.1 5.058v23.283c-.004 1.351.75 2.592 1.955 3.22.52.287 1.105.438 1.7.439.73 0 1.445-.211 2.057-.607l6.188-4.13c.296-.198.647-.298 1.003-.287H296.9c2.817 0 5.1-2.265 5.1-5.058v-16.86c0-2.793-2.283-5.058-5.1-5.058zm-6.8 18.546h-10.2c-.939 0-1.7-.755-1.7-1.686 0-.931.761-1.686 1.7-1.686h10.2c.939 0 1.7.755 1.7 1.686 0 .931-.761 1.686-1.7 1.686zm0-6.744h-10.2c-.939 0-1.7-.755-1.7-1.686 0-.931.761-1.686 1.7-1.686h10.2c.939 0 1.7.755 1.7 1.686 0 .931-.761 1.686-1.7 1.686z",
    transform: "translate(-268 -2169)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStellerCommunication);
export default __webpack_public_path__ + "static/media/icon-steller-communication.b9ab2dc321bee173de3e4ad998ff2df4.svg";
export { ForwardRef as ReactComponent };